import { render, staticRenderFns } from "./PersonProfessionRelatedBlogs.vue?vue&type=template&id=41ae4136"
import script from "./PersonProfessionRelatedBlogs.vue?vue&type=script&lang=js"
export * from "./PersonProfessionRelatedBlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports